import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { N0, N200 } from '@atlaskit/theme/colors';
import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
import styled from '@emotion/styled';
import React from 'react';
import { injectIntl } from 'react-intl';
import { useUserInfo } from '../../hook';
import { getBitbucketWorkspaces } from '../../hook/use-bitbucket-workspaces';
import {
  markDevopsLoadingStart,
  submitDevopsTimeToInteractive
} from '../../metrics';
import { DevopsFormView } from '../devops-screen/devops-form-view';
import {
  DevopsContextProps,
  DevopsProvider
} from '../devops-screen/hook/use-devops-state';
import { messages } from '../devops-screen/messages';
import { DevopsImageUrlsType } from '../devops-screen/types';

function DevopsScreenStandalone(props: DevopsContextProps) {
  const userInfo = useUserInfo();
  const bbworkspaces = getBitbucketWorkspaces(!!userInfo?.hasBitbucket) || [];
  const { createAnalyticsEvent } = useAnalyticsEvents();
  const recaptchaEulaAnalytics = () => {
    createAnalyticsEvent({
      eventName: 'bxp.formCloudSignup.reCaptchaPrivacyPolicyClicked',
      eventComponent: 'button',
      event: 'clicked'
    }).fire();
  };

  markDevopsLoadingStart();
  submitDevopsTimeToInteractive();

  return (
    <DevopsProvider {...props} userInfo={userInfo} bbworkspaces={bbworkspaces}>
      <PageRoot>
        <PageBody>
          <FormWrapper>
            <Column>
              <SignupWrapper className="signup-wrapper">
                <DevopsFormView />
              </SignupWrapper>
              <RecaptchaLegal
                className="recaptcha-legal"
                onClick={recaptchaEulaAnalytics}
              >
                <SanitizedFormattedHtmlMessage {...messages.devopsRecaptcha} />
              </RecaptchaLegal>
            </Column>
          </FormWrapper>
        </PageBody>
      </PageRoot>
    </DevopsProvider>
  );
}

export const PageRoot = styled.div<{
  readonly devopsImageUrls?: DevopsImageUrlsType;
}>`
  position: relative;
  width: 100%;
  margin: 0;
  padding: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${({ devopsImageUrls }) =>
    devopsImageUrls?.backgroundImage});
  @media only screen and (max-width: 800px) {
    background-image: none;
  }
`;

export const PageBody = styled.div`
  position: relative;
  max-width: 1200px;
  margin: auto;

  .logo-atl {
    display: block;
    margin: 26px auto 26px;
  }
`;

const FormWrapper = styled.div`
  z-index: 9;
  margin: auto;
  display: flex;
  flex-direction: row;
  flex-flow: nowrap;
  padding: 0px 48px 48px 48px;

  @media only screen and (max-width: 800px) {
    box-sizing: border-box;
    flex-flow: row wrap;
    padding: 24px;
    margin-top: 12px;
  }
`;

const Column = styled.div`
  width: 100%;

  @media only screen and (max-width: 800px) {
    width: 100%;
  }

  &.wrapper-side-info {
    padding: 0 48px 0 0;

    @media only screen and (max-width: 800px) {
      display: none;
    }
  }
`;

const SignupWrapper = styled.div`
  padding: 48px 60px;
  margin-top: 30px;
  background-color: ${N0};
  box-shadow: rgba(98, 183, 203, 0.26) 0px 8px 16px,
    rgba(98, 183, 203, 0.31) 0px 0px 1px;
  border-radius: 3px;

  form {
    max-width: none;
  }

  @media only screen and (max-width: 1200px) {
    padding: 48px;
  }

  @media only screen and (max-width: 800px) {
    padding: 0px;
    margin-top: 0px;
    box-shadow: none;
  }
`;

const RecaptchaLegal = styled.div`
  display: block;
  max-width: 296px;
  padding: 25px 0;
  margin: auto;
  text-align: center;
  font-family: Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
    Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif;
  font-size: 12px;
  line-height: 18px;
  color: ${N200};

  @media only screen and (max-width: 800px) {
    padding: 50px 0 60px 0;
  }
`;

DevopsScreenStandalone.messages = messages;
export default injectIntl(DevopsScreenStandalone);
